module.exports = __webpack_public_path__ + "media/images/patient-icons/lab-icon-207e7e407c829f6404a256c87a3a2d28.svg";